import { IActionRow } from 'interfaces'
import styled from 'styled-components'

const StyledDiv = styled.div<{ $justifyContent?: string }>`
  display: flex;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent ? $justifyContent : 'space-evenly'};
  gap: 15px;
  img {
    cursor: pointer;
    &:hover {
      opacity: 0.85;
    }
  }
  .action-disabled {
    opacity: 0.4;
    cursor: not-allowed;
    filter: grayscale(100%);
    &:hover {
      opacity: 0.4;
    }
  }
`

interface IProps {
  actions: Array<IActionRow>
  className?: string
  justifyContent?: string
  style?: any
  onClick: (actionType: ActionType) => void
}

export enum ActionType {
  Edit,
  Delete,
  Reload,
  Accept,
  Preview,
  Update,
  Common,
  Add,
  Send,
  Print,
  EditNote,
  Approve,
  EditDayOfUse,
  EditMorning,
  EditMidday,
  EditAfternoon,
  EditNight,
  EditData
}

const Actions = ({
  actions,
  onClick,
  className,
  justifyContent,
  style
}: IProps) => {
  return (
    <StyledDiv
      className={className}
      $justifyContent={justifyContent}
      style={style}>
      {actions?.map((action) => (
        <img
          key={action.actionType}
          src={action.img}
          alt=""
          className={action?.disabled ? 'action-disabled' : ''}
          onClick={() => {
            if (!action?.disabled) onClick(action.actionType)
          }}
        />
      ))}
    </StyledDiv>
  )
}

export default Actions
